/* eslint-disable @next/next/no-img-element */
import Head from "next/head";
import Image from "next/image";
import {
  Card,
  Whitespace,
  Box,
  TouchableOpacity,
  Loading,
  Spin,
} from "./../../base";
import Styled from "styled-components";
import { IProgram } from "./../../../services/typings/program";
import {
  AiOutlineSortAscending,
  AiOutlineSortDescending,
} from "react-icons/ai";
import { RiArrowDropRightLine } from "react-icons/ri";
import useQueryParams from "./../../../hooks/useQueryParams";
import { useGetPromotions } from "./../../../hooks/Promotion";
import { useCallback, useEffect } from "react";
import { themeVariables } from "./../../../themes/constants";
import { dateFormatter } from "./../../../utils/formatters";
import { useState } from "react";
import { useRouter } from "next/router";
import React from "react";

interface IProps {
  data?: IProgram[];
}

const INTRO_URL =
  "https://tiki.vn/tong-hop-uu-dai-affiliate";

const Promotion = (props: IProps) => {
  const [{ sort_by = "created_at", order = "desc" }, setSortOrder] =
    useQueryParams({
      keys: ["sort_by", "order"],
      method: "replace",
    });

  const { data, loading, mutate } = useGetPromotions({ sort_by, order });

  const { push } = useRouter();

  const [dataList, setDataList] = useState<IProgram[]>([]);

  useEffect(() => {
    if (!!data && data.length > 0) {
      setDataList(data);
    }
  }, [data, dataList]);

  const handleOnSortOrder = useCallback(
    (kind: "created_at" | "max_commission_rate") => {
      if (sort_by === kind) {
        setSortOrder({ sort_by, order: order === "desc" ? "asc" : "desc" });
      } else {
        setSortOrder({ sort_by: kind, order: "desc" });
      }
    },
    [order, setSortOrder, sort_by]
  );

  return (
    <>
      <Head>
        <title>Ưu đãi</title>
      </Head>
      <Box display="flex" flex={1} flexDirection="column" overflow="hidden">
        <TouchableOpacity
          onPress={() => (window.location.href = INTRO_URL)}
        >
          <Image
            src={require("./../../../assets/images/banner.png")}
            alt="Introduction"
            layout="responsive"
            priority={true}
          />
        </TouchableOpacity>
        <Card
          style={{
            height: 42,
            display: "flex",
            borderTop: `1px solid ${themeVariables.colors.border}`,
            borderBottom: `1px solid ${themeVariables.colors.border}`,
            boxShadow: `0px 2px 4px ${themeVariables.colors.border}`,
            zIndex: 2,
          }}
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flex={1}
          >
            <TouchableOpacity
              style={{
                color:
                  sort_by === "created_at"
                    ? themeVariables.colors.primary
                    : themeVariables.colors.grey,
                display: "flex",
                flexDirection: "row",
              }}
              onPress={() => handleOnSortOrder("created_at")}
            >
              <Box fontWeight={600}>Mới nhất</Box>
              {order !== "desc" && sort_by === "created_at" ? (
                <AiOutlineSortAscending size={20} style={{ marginLeft: 4 }} />
              ) : (
                <AiOutlineSortDescending size={20} style={{ marginLeft: 4 }} />
              )}
            </TouchableOpacity>
          </Box>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flex={1}
          >
            <TouchableOpacity
              style={{
                color:
                  sort_by === "max_commission_rate"
                    ? themeVariables.colors.primary
                    : themeVariables.colors.grey,
                display: "flex",
                flexDirection: "row",
              }}
              onPress={() => handleOnSortOrder("max_commission_rate")}
            >
              <Box fontWeight={600}>Tỉ lệ hoa hồng</Box>
              {order !== "desc" && sort_by === "max_commission_rate" ? (
                <AiOutlineSortAscending size={20} style={{ marginLeft: 4 }} />
              ) : (
                <AiOutlineSortDescending size={20} style={{ marginLeft: 4 }} />
              )}
            </TouchableOpacity>
          </Box>
        </Card>

        {loading && !dataList?.length ? (
          <Box height="100%">
            <Spin loading />
          </Box>
        ) : (
          <>
            {!!dataList && dataList.length > 0 ? (
              <Box
                display="flex"
                flex={1}
                flexDirection="column"
                overflow="auto"
              >
                {dataList.map((item: IProgram, index: number) => {
                  return (
                    <Box
                      key={item?.id}
                      borderBottom={
                        index != dataList?.length - 1
                          ? `1px solid ${themeVariables.colors.border}`
                          : undefined
                      }
                    >
                      <ListItem>
                        <TouchableOpacity
                          onPress={() =>
                            (window.location.href = `/promotion/${item.id}`)
                          }
                        >
                          <Box display="flex" flexDirection="row" flex={1}>
                            <Box>
                              <Image
                                layout="fixed"
                                src={item.thumbnail}
                                width={70}
                                height={70}
                                alt="Thumbnail"
                                placeholder="blur"
                                blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAABlBMVEXu7u7u7u4MXmA/AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAACklEQVQImWNgAAAAAgAB9HFkpgAAAABJRU5ErkJggg=="
                              />
                            </Box>
                            <Box width="70%" ml={3}>
                              <Box
                                fontSize={14}
                                fontWeight={600}
                                style={{
                                  whiteSpace: "nowrap",
                                  textOverflow: "ellipsis",
                                }}
                                overflow="hidden"
                              >
                                {item.name}
                              </Box>
                              <Box
                                width="fit-content"
                                fontSize={12}
                                mt={2}
                                fontWeight={400}
                                backgroundColor="#E2EBF5"
                                color={themeVariables.colors.primary}
                                style={{ padding: "1px 4px" }}
                              >
                                Hoa hồng tối đa {item.max_commission_rate}%
                              </Box>
                              <Box
                                color={themeVariables.colors.grey}
                                mt={2}
                                fontSize={12}
                              >
                                {dateFormatter(item.started_at)} -{" "}
                                {dateFormatter(item.ended_at)}
                              </Box>
                            </Box>
                            <Box
                              alignItems="center"
                              justifyContent="flex-end"
                              display="flex"
                              justifySelf="flex-end"
                              flex={1}
                              ml={2}
                            >
                              <RiArrowDropRightLine
                                size={32}
                                color={themeVariables.colors.grey}
                              />
                            </Box>
                          </Box>
                        </TouchableOpacity>
                      </ListItem>
                    </Box>
                  );
                })}
              </Box>
            ) : (
              <BoxEmpty>
                <span style={{ color: "#8A8A88" }}>Không có chương trình</span>
              </BoxEmpty>
            )}
          </>
        )}
      </Box>
    </>
  );
};

export default React.memo(Promotion);

const ListItem = Styled(Box)({
  display: "flex",
  alignItem: "center",
  backgroundColor: "white",
  WebkitTapHighlightColor: "transparent",
  flex: 1,
  width: "100%",
  padding: 10,
  flexDirection: "column",
});

const BoxEmpty = Styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  backgroundColor: "#FDF8E9",
  color: "white",
  padding: 12,
  borderRadius: 8,
  marginTop: 15,
  marginLeft: 30,
  marginRight: 30,
});

const StyledImage = Styled("img")({
  width: "100%",
  // height: "15%",
});
